import { newE2EPage } from "@stencil/core/testing";

describe("ux-same-height", () => {
    it("calculates the height correctly", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-same-height>
            <div class="row">
                <div class="gr-6">
                        <div class="example-common-element">
                            <div class="ux-text-headline ux-text-headline--big">
                                Lorem ipsum dolor sit amet
                            </div>
                            <p data-same-height="text">
                                Consectetur adipiscing elit, 
                                sed do eiusmod tempor incididunt ut
                            </p>
                        </div>
                    </div>
                </div>
                <div class="gr-6">
                    <div class="example-common-element">
                        <div class="ux-text-headline ux-text-headline--big">
                            Lorem ipsum dolor sit amet
                        </div>
                        <p data-same-height="text">
                            Duis aute irure dolor in reprehenderit in voluptate velit esse 
                            cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat 
                            cupidatat non proident, sunt in culpa qui officia deserunt mollit 
                            anim id est laborum.
                        </p>
                    </div>
                </div>
            </div>
        </ux-same-height>`);
        const el = await page.find("ux-same-height");
        await page.waitForChanges();
        expect(el).toHaveClass("hydrated");
        await page.waitForChanges();
        const el1 = await page.find(".gr-6:nth-of-type(1) p");
        const el2 = await page.find(".gr-6:nth-of-type(2) p");
        expect(el1.getAttribute("style")).toBe(el2.getAttribute("style"));
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-same-height>
            <div>
                Lorem ipsum dolor sit amet
            </div>
        </ux-same-height>`);
        await page.waitForChanges();
        const el = await page.find("ux-same-height");
        expect(el).toMatchSnapshot();
    });
});
